import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'

import * as constants from './constants'

export { constants }

export default Loadable(() => import('./DeleteReasonModal'))
